module.exports = __webpack_public_path__ + "media/images/pla/pla17-e5f2d957c950a911b4b9015815632a1e.jpg";